import { Button } from 'antd';
import { ActionButton } from './style';
import { AiTwotoneEdit } from 'react-icons/ai';
import * as Yup from 'yup';

export const buttons = [
  {
    id: 1,
    title: 'Баҳоланмаган',
    value: 2,
  },
  {
    id: 2,
    title: 'Баҳоланган',
    value: 3,
  },
];

export const validationSchema = Yup.object().shape({
  date: Yup.array().min(1, 'Тўлдириш мажбурий'),
});

export const getColumn = ({ handleClick }) => {
  const userTableHeader = [
    {
      id: 1,
      Header: 'Фамилия, Исм, Шариф',
      accessor: 'user_name',
      show: true,
      width: 300,
    },
    {
      id: 2,
      Header: 'Туман',
      accessor: 'region',
      align: 'center',
      show: true,
      width: 350,
    },
    {
      id: 3,
      Header: 'МФЙ',
      accessor: 'object',
      show: true,
      width: 350,
    },
    {
      id: 4,
      Header: 'Ҳолати',
      accessor: 'inActive',
      show: true,
      width: 250,
    },
    {
      id: 5,
      Header: 'Ҳаракатлар',
      show: true,
      width: 100,
      Cell: ({ row: { original } }) => {
        return (
          <ActionButton>
            <Button
              className='edit-btn'
              onClick={() => handleClick(original._id)}
              shape='circle'
              icon={<AiTwotoneEdit size={25} />}
            ></Button>
          </ActionButton>
        );
      },
    },
  ];
  return userTableHeader;
};
